<template>
  <div class="userInfo" @click="toUserInfo">
    <img class="touxiang" src="@/assets/user_img.png" alt="" />
    <div class="info">
      <div class="name">{{ item.username }}</div>
      <div class="country">
        {{ departName }}
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/utils/http.js";
export default {
  name: "userInfo",
  props: {
    item: {
      type: Object,
    },
    isHeader: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      linkList: [],
      institution: [],
      departName: "",
    };
  },
  mounted() {
    this.getInstitution();
  },
  methods: {
    getInstitution() {
      http
        .get("/depart/list")
        .then((res) => {
          if (res.success) {
            this.linkList = res.result;
            this.institution = res.result.filter(
              (item) => item.orgCode === this.item.orgCode
            );
            if (this.institution.length) {
              this.departName = this.institution[0].departName;
            }
          }
        })
        .catch((err) => {
          return err;
        });
    },
    toUserInfo() {
      this.$router.push({
        path: "/userCenter",
        query: {
          username: this.item.username,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.userInfo {
  min-width: 200px;
  height: 60px;
  display: flex;
  justify-items: center;
  cursor: pointer;
  .touxiang {
    height: 60px;
    width: 60px;
  }
  .info {
    margin-left: 10px;
    .name {
      font-size: 18px;
      color: #333333;
      margin-top: 12px;
    }
    .country {
      font-size: 14px;
      color: #666666;
      margin-top: 2px;
    }
  }
}
</style>
